import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LivroCaixa } from '../models/livro-caixa';

@Injectable({
  providedIn: 'root',
})
export class LivroCaixaService {

  private readonly url = `${environment.apiUrl}/livrocaixa`;

  constructor(private readonly http: HttpClient) {}

  selecionar(): Observable<LivroCaixa[]> {
    return this.http.get<LivroCaixa[]>(this.url);
  }

  cadastrar(obj: LivroCaixa): Observable<LivroCaixa> {
    return this.http.post<LivroCaixa>(this.url, obj);
  }

  alterar(obj: LivroCaixa): Observable<LivroCaixa> {
    return this.http.put<LivroCaixa>(this.url, obj);
  }

  deletar(id: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }

  selecionarPorData(dataInicial: string, dataFinal: string): Observable<LivroCaixa[]> {
    return this.http.get<LivroCaixa[]>(`${this.url}/por-data?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
  }

  lancar(lancamento: LivroCaixa): Observable<LivroCaixa> {
    return this.http.post<LivroCaixa>(`${this.url}/lancamento`, lancamento);
  }

}
